import HeaderLeftRegion from "./HeaderLeftRegion";
import HeaderCenterRegion from "./HeaderCenterRegion";
import HeaderRightRegion from "./HeaderRightRegion";
import { AppBar, Toolbar } from "@mui/material";

function SuiteNavHeader() {
    return (
        <AppBar
            position="fixed"
            top={0}
            eleveation={0}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                boxShadow: "none",
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            }}
        >
            <Toolbar variant="dense">
                <HeaderLeftRegion />
                <HeaderCenterRegion />
                <HeaderRightRegion />
            </Toolbar>
        </AppBar>
    );
}

export default SuiteNavHeader;
